/* Modern Mattress — Shared Product Data */
/* Campaign: Regular Pricing | Updated: 2026-04-14 */
/* AUTO-GENERATED by build-prices.py — do not edit manually */

window.MM = window.MM || {};

MM.prices = {
  modern:      { twin: 449, twinxl: 499, full: 499, queen: 599, king: 699 },
  aria:        { twin: 699, twinxl: 799, full: 899, queen: 999, king: 1199 },
  classic:     { twin: 999, twinxl: 1099, full: 1199, queen: 1299, king: 1499 },
  prestige:    { twin: 1099, twinxl: 1199, full: 1199, queen: 1399, king: 1699 },
  signature:   { twin: 1699, twinxl: 1799, full: 1899, queen: 2199, king: 2499 },
  natural:     { twin: 1999, twinxl: 2099, full: 2199, queen: 2499, king: 2799 },
  hybrid_luxe: { twin: 2599, twinxl: 2799, full: 2899, queen: 2999, king: 3499 },
  artisan:     { twin: 3199, twinxl: 3499, full: 3599, queen: 3799, king: 4299 }
};

MM.bundles = {
  classic: {
      essential: { twinxl: [3200,2398], full: [3500,2598], queen: [3700,2798], king: [4200,3098] },
      plus: { twinxl: [3700,2598], full: [4100,2998], queen: [4300,3198], king: [5200,3898] },
      pro: { twinxl: [4600,3498], queen: [5200,3898], king: [5900,4398] }
  },
  aria: {
      essential: { twinxl: [2900,2098], full: [3100,2298], queen: [3300,2498], king: [3800,2798] },
      plus: { twinxl: [3400,2298], full: [3700,2698], queen: [3900,2898], king: [4800,3598] },
      pro: { twinxl: [4300,3198], queen: [4800,3598], king: [5500,4098] }
  },
  prestige: {
      essential: { twinxl: [3300,2498], full: [3400,2598], queen: [3900,2898], king: [4400,3298] },
      plus: { twinxl: [3800,2698], full: [4000,2998], queen: [4500,3298], king: [5400,4098] },
      pro: { twinxl: [4700,3598], queen: [5400,3998], king: [6100,4598] }
  },
  signature: {
      essential: { twinxl: [4000,3098], full: [4200,3298], queen: [4700,3698], king: [5300,4098] },
      plus: { twinxl: [4500,3298], full: [4800,3698], queen: [5300,4098], king: [6300,4898] },
      pro: { twinxl: [5400,4198], queen: [6200,4798], king: [7000,5398] }
  },
  natural: {
      essential: { twinxl: [4500,3398], full: [4800,3598], queen: [5100,3998], king: [5800,4398] },
      plus: { twinxl: [5000,3598], full: [5400,3998], queen: [5700,4398], king: [6800,5198] },
      pro: { twinxl: [5900,4498], queen: [6600,5098], king: [7500,5698] }
  },
  hybrid_luxe: {
      essential: { twinxl: [5350,4098], full: [5650,4298], queen: [5850,4498], king: [6650,5098] },
      plus: { twinxl: [5850,4298], full: [6250,4698], queen: [6450,4898], king: [7650,5898] },
      pro: { twinxl: [6750,5198], queen: [7350,5598], king: [8350,6398] }
  },
  artisan: {
      essential: { twinxl: [6200,4798], full: [6500,4998], queen: [7300,5298], king: [8000,5898] },
      plus: { twinxl: [6700,4998], full: [7100,5398], queen: [7900,5698], king: [9000,6698] },
      pro: { twinxl: [7600,5898], queen: [8800,6398], king: [9700,7198] }
  }
};

MM.variants = {
  classic: {
    essential: {
      twinxl: { firm: 47596599312571, medium: 47596599410875, soft: 47596599509179 },
      full: { firm: 47596599607483, medium: 47596599673019, soft: 47596599738555 },
      queen: { firm: 47596599804091, medium: 47596599902395, soft: 47596600000699 },
      king: { firm: 47596600099003, medium: 47596600197307, soft: 47596600295611 }
    },
    plus: {
      twinxl: { firm: 47596600394915, medium: 47596600493219, soft: 47596600591523 },
      full: { firm: 47596600689827, medium: 47596600755363, soft: 47596600820899 },
      queen: { firm: 47596600886435, medium: 47596600984739, soft: 47596601083043 },
      king: { firm: 47596601181347, medium: 47596601279651, soft: 47596601377955 }
    },
    pro: {
      twinxl: { firm: 47596601476259, medium: 47596601574563, soft: 47596601672867 },
      full: { firm: 47596601771171, medium: 47596601836707, soft: 47596601902243 },
      queen: { firm: 47596601967779, medium: 47596602066083, soft: 47596602164387 },
      king: { firm: 47596602262691, medium: 47596602360995, soft: 47596602459299 }
    }
  },
  aria: {
    essential: {
      twinxl: { firm: 47541316550843, medium: 47541316649147, soft: 47541316747451 },
      full: { firm: 47541316845755, medium: 47541316911291, soft: 47541316976827 },
      queen: { firm: 47541317042363, medium: 47541317140667, soft: 47541317238971 },
      king: { firm: 47541317337275, medium: 47541317435579, soft: 47541317533883 }
    },
    plus: {
      twinxl: { firm: 47541317632187, medium: 47541317730491, soft: 47541317828795 },
      full: { firm: 47541317927099, medium: 47541317992635, soft: 47541318058171 },
      queen: { firm: 47541318123707, medium: 47541318222011, soft: 47541318320315 },
      king: { firm: 47541318418619, medium: 47541318516923, soft: 47541318615227 }
    },
    pro: {
      twinxl: { firm: 47541318713531, medium: 47541318811835, soft: 47541318910139 },
      full: { firm: 47541319008443, medium: 47541319073979, soft: 47541319139515 },
      queen: { firm: 47541319204851, medium: 47541319303155, soft: 47541319401459 },
      king: { firm: 47541319499763, medium: 47541319598067, soft: 47541319696371 }
    }
  },
  prestige: {
    essential: {
      twinxl: { firm: 47596435112123, medium: 47596435210427, soft: 47596435308731 },
      full: { firm: 47596435407035, medium: 47596435472571, soft: 47596435538107 },
      queen: { firm: 47596435603643, medium: 47596435701947, soft: 47596435800251 },
      king: { firm: 47596435898555, medium: 47596435996859, soft: 47596436095163 }
    },
    plus: {
      twinxl: { firm: 47596436193467, medium: 47596436291771, soft: 47596436390075 },
      full: { firm: 47596436488379, medium: 47596436553915, soft: 47596436619451 },
      queen: { firm: 47596436684987, medium: 47596436783291, soft: 47596436881595 },
      king: { firm: 47596436979899, medium: 47596437078203, soft: 47596437176507 }
    },
    pro: {
      twinxl: { firm: 47596437274811, medium: 47596437373115, soft: 47596437471419 },
      full: { firm: 47596437569723, medium: 47596437635259, soft: 47596437700795 },
      queen: { firm: 47596437766331, medium: 47596437864635, soft: 47596437962939 },
      king: { firm: 47596438061243, medium: 47596438159547, soft: 47596438257851 }
    }
  },
  signature: {
    essential: {
      twinxl: { firm: 47541265301691, medium: 47541265400995, soft: 47541265499299 },
      full: { firm: 47541265597603, medium: 47541265663139, soft: 47541265728675 },
      queen: { firm: 47541265794211, medium: 47541265892515, soft: 47541265990819 },
      king: { firm: 47541266089123, medium: 47541266187427, soft: 47541266285731 }
    },
    plus: {
      twinxl: { firm: 47541266384035, medium: 47541266482339, soft: 47541266580643 },
      full: { firm: 47541266678947, medium: 47541266744483, soft: 47541266810019 },
      queen: { firm: 47541266875555, medium: 47541266973859, soft: 47541267072163 },
      king: { firm: 47541267170467, medium: 47541267268771, soft: 47541267367075 }
    },
    pro: {
      twinxl: { firm: 47541267465379, medium: 47541267563683, soft: 47541267661987 },
      full: { firm: 47541267760291, medium: 47541267825827, soft: 47541267891363 },
      queen: { firm: 47541267956899, medium: 47541268055203, soft: 47541268153507 },
      king: { firm: 47541268251811, medium: 47541268350115, soft: 47541268448419 }
    }
  },
  natural: {
    essential: {
      twinxl: { firm: 47596481118395, medium: 47596481216699, soft: 47596481315003 },
      full: { firm: 47596481413307, medium: 47596481478843, soft: 47596481544379 },
      queen: { firm: 47596481609915, medium: 47596481708219, soft: 47596481806523 },
      king: { firm: 47596481904827, medium: 47596482003131, soft: 47596482101435 }
    },
    plus: {
      twinxl: { firm: 47596482199739, medium: 47596482298043, soft: 47596482396347 },
      full: { firm: 47596482494651, medium: 47596482560187, soft: 47596482625723 },
      queen: { firm: 47596482691259, medium: 47596482789563, soft: 47596482887867 },
      king: { firm: 47596482986171, medium: 47596483084475, soft: 47596483182779 }
    },
    pro: {
      twinxl: { firm: 47596483281083, medium: 47596483379387, soft: 47596483477691 },
      full: { firm: 47596483575995, medium: 47596483641531, soft: 47596483707067 },
      queen: { firm: 47596483772603, medium: 47596483870907, soft: 47596483969211 },
      king: { firm: 47596484067515, medium: 47596484165819, soft: 47596484264123 }
    }
  },
  hybrid_luxe: {
    essential: {
      twinxl: { firm: 47541327921339, medium: 47541328019643, soft: 47541328117947 },
      full: { firm: 47541328216251, medium: 47541328281787, soft: 47541328347323 },
      queen: { firm: 47541328412859, medium: 47541328511163, soft: 47541328609467 },
      king: { firm: 47541328707771, medium: 47541328806075, soft: 47541328904379 }
    },
    plus: {
      twinxl: { firm: 47541329002683, medium: 47541329100987, soft: 47541329199291 },
      full: { firm: 47541329297595, medium: 47541329363131, soft: 47541329428667 },
      queen: { firm: 47541329494203, medium: 47541329592507, soft: 47541329690811 },
      king: { firm: 47541329789115, medium: 47541329887419, soft: 47541329985723 }
    },
    pro: {
      twinxl: { firm: 47541330084027, medium: 47541330182331, soft: 47541330280635 },
      full: { firm: 47541330378939, medium: 47541330444475, soft: 47541330510011 },
      queen: { firm: 47541330575547, medium: 47541330673851, soft: 47541330772155 },
      king: { firm: 47541330870459, medium: 47541330968763, soft: 47541331067067 }
    }
  },
  artisan: {
    essential: {
      twinxl: { firm: 47596553666747, medium: 47596553765051, soft: 47596553863355 },
      full: { firm: 47596553961659, medium: 47596554027195, soft: 47596554092731 },
      queen: { firm: 47596554158267, medium: 47596554256571, soft: 47596554354875 },
      king: { firm: 47596554453179, medium: 47596554551483, soft: 47596554649787 }
    },
    plus: {
      twinxl: { firm: 47596554748091, medium: 47596554846395, soft: 47596554944699 },
      full: { firm: 47596555043003, medium: 47596555108539, soft: 47596555174075 },
      queen: { firm: 47596555239611, medium: 47596555337915, soft: 47596555436219 },
      king: { firm: 47596555534523, medium: 47596555632827, soft: 47596555731131 }
    },
    pro: {
      twinxl: { firm: 47596555829435, medium: 47596555927739, soft: 47596556026043 },
      full: { firm: 47596556124347, medium: 47596556189883, soft: 47596556255419 },
      queen: { firm: 47596556320955, medium: 47596556419259, soft: 47596556517563 },
      king: { firm: 47596556615867, medium: 47596556714171, soft: 47596556812475 }
    }
  }
};

MM.financing = {
  months: 12,
  apr: 0,
  adminFee: 90,
  taxRate: 0.11,
  monthly: function(price) { return Math.round((price + this.adminFee) / this.months); }
};

MM.stores = [
  { name: "Saskatoon North", address: "601 51st St", city: "Saskatoon", phone: "(306) 249-3032" },
  { name: "Saskatoon Rosewood", address: "90-3020 Meadows Parkway", city: "Saskatoon", phone: "(306) 242-3400" },
  { name: "Regina Prince of Wales", address: "2030 Prince of Wales Dr", city: "Regina", phone: "(306) 761-0169" },
  { name: "Regina Outlet", address: "4123 Rochdale Blvd", city: "Regina", phone: "(306) 546-2003" },
  { name: "Moose Jaw", address: "27B McKenzie Ln", city: "Moose Jaw", phone: "(306) 693-8881" },
  { name: "Yorkton", address: "12B Livingstone Street", city: "Yorkton", phone: "(306) 783-0464" }
];
MM.hours = "Mon–Wed 10am–6pm, Thu–Fri 10am–8pm, Sat 10am–6pm, Sun 11am–5pm";
